import React, { useEffect } from 'react';

function SEOHead({ article }) {
  useEffect(() => {
    if (!article) return;

    const siteUrl = window.location.origin;
    const articleUrl = `${siteUrl}/article/${article.slug}`;
    const imageUrl = article.thumbnail || `${siteUrl}/logo.png`;
    
    // Format publish date for structured data
    const publishDate = article.publish_date ? new Date(article.publish_date).toISOString() : new Date().toISOString();
    const modifiedDate = article.date_modified ? new Date(article.date_modified).toISOString() : publishDate;

    // Update document title
    document.title = `${article.meta_title || article.title} | Inside Injuries`;

    // Update or create meta tags
    const updateMetaTag = (name, content, property = false) => {
      const attr = property ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Primary Meta Tags
    updateMetaTag('title', article.meta_title || article.title);
    updateMetaTag('description', article.meta_desc || `Read ${article.title} on Inside Injuries - Your source for sports injury insights and analysis.`);
    updateMetaTag('keywords', article.tags ? article.tags.join(', ') : `${article.category}, sports injuries, injury analysis`);

    // Open Graph / Facebook
    updateMetaTag('og:type', 'article', true);
    updateMetaTag('og:url', articleUrl, true);
    updateMetaTag('og:title', article.meta_title || article.title, true);
    updateMetaTag('og:description', article.meta_desc || `Read ${article.title} on Inside Injuries`, true);
    updateMetaTag('og:image', imageUrl, true);
    updateMetaTag('og:site_name', 'Inside Injuries', true);
    updateMetaTag('article:published_time', publishDate, true);
    updateMetaTag('article:modified_time', modifiedDate, true);
    updateMetaTag('article:author', 'Josh Irons', true);
    updateMetaTag('article:section', article.category, true);

    // Twitter
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:url', articleUrl);
    updateMetaTag('twitter:title', article.meta_title || article.title);
    updateMetaTag('twitter:description', article.meta_desc || `Read ${article.title} on Inside Injuries`);
    updateMetaTag('twitter:image', imageUrl);
    updateMetaTag('twitter:creator', '@insideinjuries');
    updateMetaTag('twitter:site', '@insideinjuries');

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', articleUrl);

    // Create structured data for Article
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": article.title,
      "description": article.meta_desc || article.title,
      "image": imageUrl,
      "datePublished": publishDate,
      "dateModified": modifiedDate,
      "author": {
        "@type": "Person",
        "name": "Josh Irons"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Inside Injuries",
        "logo": {
          "@type": "ImageObject",
          "url": `${siteUrl}/logo.png`
        }
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": articleUrl
      },
      "articleSection": article.category,
      "keywords": article.tags ? article.tags.join(', ') : ''
    };

    // Add or update structured data script
    let structuredDataScript = document.querySelector('script[type="application/ld+json"]');
    if (!structuredDataScript) {
      structuredDataScript = document.createElement('script');
      structuredDataScript.setAttribute('type', 'application/ld+json');
      document.head.appendChild(structuredDataScript);
    }
    structuredDataScript.textContent = JSON.stringify(structuredData);

    // Cleanup function to reset title on unmount
    return () => {
      document.title = 'Inside Injuries';
    };
  }, [article]);

  return null;
}

export default SEOHead;
